import React, { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Spinner
} from 'reactstrap';
import axios from 'axios';
import { getAnounce, getAnounceAgents, postuler } from 'store/auth/profile/profileSlice';
import { useDispatch } from 'react-redux';

const ApplicationModal = ({ isOpen, toggle, announcementId }) => {
  const [message, setMessage] = useState('');
  const [video, setVideo] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch()

  const handleVideoChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setVideo(e.target.files[0]);
    }
  };

  const handleDocumentsChange = (e) => {
    if (e.target.files) {
      setDocuments(Array.from(e.target.files));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form
    if (!message.trim()) {
      setError('Le message est obligatoire');
      return;
    }

    setLoading(true);
    setError('');

    // Create form data
    const formData = new FormData();
    formData.append('announcementId', announcementId);
    formData.append('message', message);

    if (video) {
      formData.append('video', video);
    }

    if (documents.length > 0) {
      documents.forEach(doc => {
        formData.append('additionalDocuments', doc);
      });
    }

    try {
      // Replace with your actual API endpoint
      const response = await dispatch(postuler(formData))

      setSuccess(true);
      await dispatch(getAnounce())
      await dispatch(getAnounceAgents())
      setTimeout(() => {
        setSuccess(false);
        resetForm();
        toggle();
      }, 2000);

    } catch (err) {
      setError(err?.response?.data?.message || 'Une erreur est survenue lors de la soumission');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setMessage('');
    setVideo(null);
    setDocuments([]);
    setError('');
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Postuler à l&apos;annonce</ModalHeader>
      <ModalBody>
        {success ? (
          <div className="text-center py-4">
            <div className="text-success mb-3">
              <i className="fas fa-check-circle fa-3x"></i>
            </div>
            <h4 className="text-success">Candidature envoyée avec succès!</h4>
          </div>
        ) : (
          <Form onSubmit={handleSubmit}>
            {error && <div className="alert alert-danger">{error}</div>}

            <FormGroup>
              <Label for="message">Message *</Label>
              <Input
                type="textarea"
                name="message"
                id="message"
                rows="5"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
                placeholder="Expliquez pourquoi vous postulez à cette annonce..."
              />
            </FormGroup>

            <FormGroup>
              <Label for="video">Vidéo</Label>
              <Input
                type="file"
                name="video"
                id="video"
                onChange={handleVideoChange}
                accept="video/*"
              />
              <FormText color="muted">
                Téléchargez une vidéo de présentation ou démonstration de vos compétences.
              </FormText>
              {video && (
                <div className="mt-2">
                  <span className="text-primary">
                    <i className="fas fa-file-video mr-2"></i> {video?.name}
                  </span>
                </div>
              )}
            </FormGroup>

            <FormGroup>
              <Label for="documents">Documents supplémentaires</Label>
              <Input
                type="file"
                name="documents"
                id="documents"
                onChange={handleDocumentsChange}
                multiple
              />
              <FormText color="muted">
                Téléchargez des documents supplémentaires (CV, certificats, etc.)
              </FormText>
              {documents.length > 0 && (
                <div className="mt-2">
                  <p className="mb-1">Documents sélectionnés:</p>
                  <ul className="list-unstyled">
                    {documents.map((doc, index) => (
                      <li key={index} className="text-primary">
                        <i className="fas fa-file mr-2"></i> {doc?.name}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </FormGroup>
          </Form>
        )}
      </ModalBody>
      {!success && (
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>Annuler</Button>
          <Button
            color="primary"
            onClick={handleSubmit}
            disabled={loading || !message.trim()}
          >
            {loading ? <Spinner size="sm" /> : 'Postuler'}
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
};

export default ApplicationModal;